import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hpc_checkbox_normal",
  "use": "icon-hpc_checkbox_normal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-hpc_checkbox_normal\">\n<rect x=\"0.75\" y=\"0.75\" width=\"14.5\" height=\"14.5\" rx=\"1.25\" fill=\"white\" stroke=\"#D3D3D3\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hpc_checkbox_normal.svg
// module id = b4wL
// module chunks = 87